/* MOQ & quantity-increment enforcement.
   Pairs with snippets/moq-rule.liquid which prints data-moq / data-inc on
   each quantity input. Rule: q is valid iff q >= moq AND (q - moq) % inc === 0. */
(function () {
  'use strict';

  var ERR_CLASS = 'moq-invalid';
  var NOTE_CLASS = 'moq-note';

  function ruleOf(input) {
    var moq = parseInt(input.getAttribute('data-moq'), 10);
    var inc = parseInt(input.getAttribute('data-inc'), 10);
    if (!moq || moq < 1) moq = 1;
    if (!inc || inc < 1) inc = 1;
    return { moq: moq, inc: inc };
  }

  function isControlled(rule) {
    return rule.moq > 1 || rule.inc > 1;
  }

  function isValid(qty, rule) {
    if (!Number.isFinite(qty)) return false;
    if (qty < rule.moq) return false;
    return (qty - rule.moq) % rule.inc === 0;
  }

  function message(rule) {
    if (rule.inc > 1 && rule.inc !== rule.moq) {
      return 'Minimum order ' + rule.moq + ', then in multiples of ' + rule.inc + '.';
    }
    return 'Sold in multiples of ' + rule.moq + ' (minimum ' + rule.moq + ').';
  }

  /* The buttons that must be blocked for a given product form. */
  function formButtons(form) {
    var sel = 'button[type="submit"], [name="add"], .shopify-payment-button button, .shopify-payment-button [role="button"]';
    var inForm = Array.prototype.slice.call(form.querySelectorAll(sel));
    if (form.id) {
      // Theme renders sticky/quick-buy buttons outside the form via form="<id>".
      inForm = inForm.concat(
        Array.prototype.slice.call(document.querySelectorAll('button[form="' + form.id + '"]'))
      );
    }
    return inForm;
  }

  function setFormBlocked(form, blocked) {
    formButtons(form).forEach(function (btn) {
      btn.classList.toggle('moq-blocked', blocked);
      btn.toggleAttribute('disabled', blocked);
    });
  }

  /* Ensure a single note element lives next to the input's .input-amount wrapper. */
  function renderNote(input, rule) {
    var holder = input.closest('.input-amount') || input.parentNode;
    if (!holder || !holder.parentNode) return;
    var note = holder.parentNode.querySelector('.' + NOTE_CLASS);
    if (!isControlled(rule)) {
      if (note) note.remove();
      return;
    }
    if (!note) {
      note = document.createElement('small');
      note.className = NOTE_CLASS;
      holder.parentNode.insertBefore(note, holder.nextSibling);
    }
    note.textContent = message(rule);
  }

  function markInput(input, valid) {
    input.classList.toggle(ERR_CLASS, !valid);
    input.setAttribute('aria-invalid', valid ? 'false' : 'true');
  }

  /* ---- Product forms (PDP / sticky / quick-buy) ---- */

  function productQtyInputs() {
    return Array.prototype.slice.call(
      document.querySelectorAll('input[name="quantity"][data-moq], input[name="product_qty_sticky"][data-moq]')
    );
  }

  function linkedTwin(input) {
    var sel = input.getAttribute('data-link');
    if (!sel) return null;
    try {
      return document.querySelector(sel);
    } catch (e) {
      return null;
    }
  }

  /* Block the input's own form AND the linked twin's form. The sticky input
     lives in its own form but its Add button targets the main product form
     (which is the twin's form); setFormBlocked also disables out-of-form
     buttons via form="<id>", so blocking the twin's form catches them all. */
  function blockProductForms(input, blocked) {
    var forms = [];
    function add(form) {
      if (form && forms.indexOf(form) === -1) {
        forms.push(form);
        setFormBlocked(form, blocked);
      }
    }
    add(input.closest('form'));
    var twin = linkedTwin(input);
    if (twin) add(twin.closest('form'));
  }

  function validateProductInput(input) {
    var rule = ruleOf(input);
    renderNote(input, rule);
    var qty = parseInt(input.value, 10);
    var valid = !isControlled(rule) || isValid(qty, rule);
    markInput(input, valid);
    var twin = linkedTwin(input);
    if (twin) markInput(twin, valid);
    blockProductForms(input, !valid);
    return valid;
  }

  /* The sticky bar is not re-rendered on variant change, but the main PDP
     input (#quantity) is. Copy the fresh rule onto the linked sticky twin so
     its validation, helper text, and gating reflect the current variant. */
  function syncStickyFromMain() {
    var main = document.getElementById('quantity');
    if (!main || !main.hasAttribute('data-moq')) return;
    var sticky = document.getElementById('product_qty_sticky');
    if (!sticky) return;
    ['data-moq', 'data-inc', 'min', 'step'].forEach(function (attr) {
      var val = main.getAttribute(attr);
      if (val !== null) sticky.setAttribute(attr, val);
    });
  }

  function refresh() {
    syncStickyFromMain();
    productQtyInputs().forEach(validateProductInput);
    validateCart();
  }

  /* ---- Cart (page + drawer) ---- */

  function cartInputs() {
    return Array.prototype.slice.call(
      document.querySelectorAll('input[name="updates[]"][data-moq]')
    );
  }

  function checkoutButtons() {
    return Array.prototype.slice.call(
      document.querySelectorAll('button[name="checkout"], input[type="submit"][name="checkout"]')
    );
  }

  function validateCart() {
    var inputs = cartInputs();
    if (!inputs.length) return;
    var anyInvalid = false;
    inputs.forEach(function (input) {
      var rule = ruleOf(input);
      var qty = parseInt(input.value, 10);
      var valid = !isControlled(rule) || isValid(qty, rule);
      markInput(input, valid);
      if (!valid) anyInvalid = true;
    });
    checkoutButtons().forEach(function (btn) {
      btn.classList.toggle('moq-blocked', anyInvalid);
      btn.toggleAttribute('disabled', anyInvalid);
    });
  }

  /* ---- Delegated listeners (survive re-renders) ---- */

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!(t instanceof HTMLInputElement) || !t.hasAttribute('data-moq')) return;
    if (t.name === 'updates[]') validateCart();
    else validateProductInput(t);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof HTMLInputElement) || !t.hasAttribute('data-moq')) return;
    if (t.name === 'updates[]') validateCart();
    else validateProductInput(t);
  });

  // Capture-phase submit guard: runs before the theme's ajaxCart bubble handler.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var input = form.querySelector('input[name="quantity"][data-moq], input[name="product_qty_sticky"][data-moq]');
    if (!input) return;
    var rule = ruleOf(input);
    if (!isControlled(rule)) return;
    if (!isValid(parseInt(input.value, 10), rule)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      markInput(input, false);
      renderNote(input, rule);
      setFormBlocked(form, true);
    }
  }, true);

  // Re-scan after the theme re-renders sections (variant change, cart update, drawer load).
  window.addEventListener('semanticInput', refresh);
  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
})();
